import React, { useLayoutEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import useLocationSearch from '@/hooks/use-location-search'
import { Modal, Form, Input, Button, message } from 'antd'
import { login } from '../../services/loginService'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { isSigned } from '@/utils/session'
import './index.scss'
export interface ILoginDialog {
  visible: boolean
  onCancel?: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
  onConfirm?: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
  afterLogin?: any
  form: any
  history: any
  location: any
}

function Login(props) {
  const { afterLogin, onCancel, onConfirm, visible = true } = props
  const [form] = Form.useForm()
  const history = useHistory()
  const { redirect } = useLocationSearch()
  const getDecodeRedirect = () => {
    return redirect ? decodeURIComponent(redirect) : '/'
  }
  const historyRef = useRef(history)
  historyRef.current = history

  useLayoutEffect(() => {
    if (isSigned()) {
      historyRef.current.replace('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleSubmit = values => {
    const hide = message.loading('Logging in, please wait...', 0)
    // login
    login(values.name, values.password)
      .then(res => {
        if (res.data) {
          message.success('Login success')
          if (afterLogin) {
            afterLogin(
              {
                ...res.data,
                name: values.name,
              },
              null
            )
          }
          const pathname = getDecodeRedirect()
          history.replace(pathname.startsWith('/login') ? '/' : pathname)
        }
        hide()
      })
      .catch(error => {
        message.error('Login failed, message: ' + (error && error.message))
        if (afterLogin) {
          afterLogin(null, error)
        }
        hide()
      })
  }

  return (
    <Modal
      title="Login"
      visible={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      className={classNames('login-dialog')}
      footer={null}
      closable={false}
    >
      <Form form={form} onFinish={handleSubmit} className="login-form">
        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Input
            prefix={
              <UserOutlined className="site-form-item-icon" style={{ color: 'rgba(0,0,0,.25)' }} />
            }
            placeholder="username"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your Password!',
            },
          ]}
        >
          <Input
            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="password"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Login
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Login
